import { render, staticRenderFns } from "./AmbassadorshipCard.vue?vue&type=template&id=1ad5ea88"
import script from "./AmbassadorshipCard.vue?vue&type=script&lang=js"
export * from "./AmbassadorshipCard.vue?vue&type=script&lang=js"
import style0 from "./AmbassadorshipCard.vue?vue&type=style&index=0&id=1ad5ea88&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports